import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { AccountsReceivableLedgerActionTypes } from '../State/actions/accounting.actions';
import {
    getAccountsReceivableLedgersFetched,
    getAccountsReceivableLedgersLatestUpdatedAt,
} from '../State/selectors/accounting.selector';
import { BaseEntityReloadResolver2 } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class AccountsReceivableLedgerResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getAccountsReceivableLedgersFetched, getAccountsReceivableLedgersLatestUpdatedAt, AccountsReceivableLedgerActionTypes.GetAccountsReceivableLedger, store);
    }
}
